var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"MainLayout-wrapper"},[_c('header',{staticClass:"MainLayout-header"},[_c('Header')],1),_c('sidebar'),_c('main',{staticClass:"MainLayout-main"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }